<template>
	<div>
		<input type="hidden" :value="validate">
		<div class="row mb-3">
			<div class="col-lg-4">
				<label>Fecha</label>
				<v-date-picker v-model="ProyectoReporteObra.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-4" v-if="ProyectoReporteObra.IdProyectoReporteObra>0 && !['','1','2','3','4','5','6','7','8','9'].includes(ProyectoReporteObra.Item)">
				<label>Item *</label>
				<input type="text" v-model="ProyectoReporteObra.Item" class="form-control" placeholder="Item"/>
				<Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="errorvalidacion.Item[0]"></Cvalidation>
			</div>
			<div class="col-lg-4" v-else-if="['1','2','3','4','5','6','7','8','9'].includes(ProyectoReporteObra.Item)">
				<label>Item *</label>
				<select v-model="ProyectoReporteObra.Item" class="form-control">
					<option value="">-Item-</option>
					<option value="1">Instalación Mecánica</option>
					<option value="2">Instalación Control</option>
					<option value="3">Instalación Eléctrica</option>
					<option value="4">Montaje Equipos</option>
					<option value="5">Limpieza</option>
					<option value="6">Trabajos Civiles</option>
					<option value="7">Seguridad</option>
					<option value="8">Retrabajo / Garantía</option>
					<option value="9">Otros</option>
					<option v-for="(item,index) in ListaProyectoPrograma" :key="index" :value="item.IdProyectoPrograma">{{item.Titulo}}</option>
				</select>
			</div>
			<div class="col-lg-4" v-else>
				<label>Item *</label>
				<select v-model="ProyectoReporteObra.IdProyectoPrograma" class="form-control">
					<option value="">-Item-</option>
					<option v-for="(item,index) in ListaProyectoPrograma" :key="index" :value="item.IdProyectoPrograma">{{item.Titulo}}</option>
				</select>
			</div>
			<div class="col-lg-3">
				<label>Avance *</label>
				<select v-model="ProyectoReporteObra.Avance" class="form-control">
					<option value="">- Avance -</option>
					<option v-for="(item,index) in ListaAvance" :value="item" :key="index">{{item+'%'}}</option>
				</select>
				<!-- <vue-numeric
					class="form-control"
					separator=","
					currency="%"
					currency-symbol-position="suffix"
					placeholder="0 %"
					:precision="0"
					:max="100"
					:min="0"
					v-model="ProyectoReporteObra.Avance"
				></vue-numeric> -->
				<Cvalidation v-if="this.errorvalidacion.Avance" :Mensaje="errorvalidacion.Avance[0]"></Cvalidation>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-3">
				<label>Estatus Día *</label>
				<select v-model="ProyectoReporteObra.EstatusDia" class="form-control">
					<option value="">-Estatus-</option>
					<option value="1">Verde</option>
					<option value="2">Amarillo</option>
					<option value="3">Rojo</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.EstatusDia" :Mensaje="errorvalidacion.EstatusDia[0]"></Cvalidation>
			</div>
			<div class="col-lg-4">
				<label>Oportunidad</label>
				<input type="text" v-model="ProyectoReporteObra.Oportunidad" class="form-control" placeholder="Oportunidad"/>
			</div>
			<div class="col-lg-2">
				<label>Atraso *</label>
				<select v-model="ProyectoReporteObra.Atraso" class="form-control">
					<option value="">-Atraso-</option>
					<option value="1">SI</option>
					<option value="2">NO</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.Atraso" :Mensaje="errorvalidacion.Atraso[0]"></Cvalidation>
			</div>
			<div class="col-lg-3">
				<label>Acción</label>
				<input type="text" v-model="ProyectoReporteObra.Accion" class="form-control" placeholder="Acción"/>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-lg-12">
				<label>Descripción</label>
				<textarea v-model="ProyectoReporteObra.Descripcion" class="form-control" cols="30" rows="4" placeholder="Descripción"></textarea>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<label>Evidencia</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo1()" type="file" accept="application/pdf" ref="archivouno" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoUno" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
			<div class="col-lg-6" v-show="false">
				<label>Evidencia 2</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo2()" type="file" accept="application/pdf" ref="archivodos" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="ArchivoDos" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"ReporteObra",
    props:["poBtnSave","pIdProyecto","pListProyectoReporteObra"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'ReporteObra',
            EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoReporteObra:{
				IdProyectoReporteObra:0,
				IdProyecto:0,
				IdProyectoPrograma:"",
				Fecha:'',
				Item:'',
				Descripcion:'',
				EstatusDia:'',
				Oportunidad:'',
				Atraso:'',
				Avance:'',
				Accion:'',
				ArchivoUno:'',
				ArchivoDos:''
			},
			ArchivoUno:'Elegir Archivo (0.5MB)',
			ArchivoDos:'Elegir Archivo (0.5MB)',
			errorvalidacion:[],
			ListProyectoReporteObra:[],
			ListaAvance:[5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100],
			ListaProyectoPrograma:[]
		}
	},
	methods: {
		Guardar(){
			let Fecha='';
			if (this.ProyectoReporteObra.Fecha!='' && this.ProyectoReporteObra.Fecha!=undefined) {
                let day=this.ProyectoReporteObra.Fecha.getDate();
                let month=this.ProyectoReporteObra.Fecha.getMonth()+1;
                let year=this.ProyectoReporteObra.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			//DETERMINAR LA LISTA QUE SE VA A MANEJAR
			let ArrayInclude=['1','2','3','4','5','6','7','8','9'];
			let ListProyectoReporteObra=[];
			if (ArrayInclude.includes(this.ProyectoReporteObra.Item)) {
				ListProyectoReporteObra=this.ListProyectoReporteObra.filter((Element) => {
					if (Element.TipoPrograma==null) {
						return true;
					}
					else{
						return false;
					}
				});
			}
			else{
				ListProyectoReporteObra=this.ListProyectoReporteObra.filter((Element) => {
					if (Element.TipoPrograma==this.ProyectoReporteObra.IdProyectoPrograma) {
						return true;
					}
					else{
						return false;
					}
				});
			}
			ListProyectoReporteObra.sort((a, b) => {b.FechaReg-a.FechaReg});
			// console.log(ListProyectoReporteObra);
			// return false;
			//LOGICA DE LISTADO APLICADA A LISTADO YA FILTRADO
			let CantidadItemsProgreso=0;
			CantidadItemsProgreso=ListProyectoReporteObra.length;
			if (this.ProyectoReporteObra.IdProyectoReporteObra==0) {
				if (CantidadItemsProgreso>0 && parseInt(this.ProyectoReporteObra.Avance)<=parseInt(ListProyectoReporteObra[CantidadItemsProgreso-1].Avance)) {
					this.$toast.warning('El Porcentaje de Avance no Puede Ser Menor al Último Registrado');
					return false;
				}
			}
			else{
				if (CantidadItemsProgreso>1 && parseInt(this.ProyectoReporteObra.Avance)<=parseInt(ListProyectoReporteObra[CantidadItemsProgreso-2].Avance)) {
					this.$toast.warning('El Porcentaje de Avance no Puede Ser Menor al Último Registrado');
					return false;
				}
			}
			// let ArrayInclude=['1','2','3','4','5','6','7','8','9','10'];
			let formData=new FormData();
			formData.set('IdProyectoReporteObra',this.ProyectoReporteObra.IdProyectoReporteObra);
			formData.set('IdProyecto',this.ProyectoReporteObra.IdProyecto);
			formData.set('Fecha',Fecha);
			formData.set('Item',this.ProyectoReporteObra.Item);
			formData.set('Descripcion',this.ProyectoReporteObra.Descripcion);
			formData.set('EstatusDia',this.ProyectoReporteObra.EstatusDia);
			formData.set('Oportunidad',this.ProyectoReporteObra.Oportunidad);
			formData.set('Atraso',this.ProyectoReporteObra.Atraso);
			formData.set('Avance',this.ProyectoReporteObra.Avance);
			formData.set('Accion',this.ProyectoReporteObra.Accion);
			formData.set('ArchivoUno',this.ProyectoReporteObra.ArchivoUno);
			formData.set('ArchivoDos',this.ProyectoReporteObra.ArchivoDos);
			formData.set('IdProyectoPrograma',this.ProyectoReporteObra.IdProyectoPrograma);
			let image=this.$refs.archivouno.files[0];
			formData.append('ArchivoUnoFile',image);
			let image2=this.$refs.archivodos.files[0];
			formData.append('ArchivoDosFile',image2);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectoreporteobra/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#ReporteObra").modal("hide");
				this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoReporteObra={
				IdProyectoReporteObra:0,
				IdProyecto:0,
				IdProyectoPrograma:"",
				Fecha:new Date(),
				Item:'',
				Descripcion:'',
				EstatusDia:'',
				Oportunidad:'',
				Atraso:'',
				Avance:'',
				Accion:'',
				ArchivoUno:'',
				ArchivoDos:''
			};
			this.ArchivoUno='Elegir Archivo (0.5MB)';
			this.ArchivoDos='Elegir Archivo (0.5MB)';
			this.errorvalidacion=[];
			this.ListaProyectoPrograma=[];
		},
		Recuperar(){
			this.$http.get('proyectoreporteobra/recovery',{
                params:{
                    IdProyectoReporteObra:this.ProyectoReporteObra.IdProyectoReporteObra
                }
            }).then((res)=>{
				const objres=res.data.data.proyectoreporteobra;
				this.ProyectoReporteObra.IdProyectoReporteObra=objres.IdProyectoReporteObra;
				this.ProyectoReporteObra.IdProyecto=objres.IdProyecto;
				this.ProyectoReporteObra.IdProyectoPrograma=objres.IdProyectoPrograma;
				this.ProyectoReporteObra.Item=objres.Item;
				this.ProyectoReporteObra.Descripcion=objres.Descripcion;
				this.ProyectoReporteObra.EstatusDia=objres.EstatusDia;
				this.ProyectoReporteObra.Oportunidad=objres.Oportunidad;
				this.ProyectoReporteObra.Atraso=objres.Atraso;
				this.ProyectoReporteObra.Avance=objres.Avance;
				this.ProyectoReporteObra.Accion=objres.Accion;
				this.ProyectoReporteObra.ArchivoUno=objres.ArchivoUno;
				this.ProyectoReporteObra.ArchivoDos=objres.ArchivoDos;
				let formatedDate = objres.Fecha.replace(/-/g, "\/");
				this.ProyectoReporteObra.Fecha=new Date(formatedDate);
				this.ArchivoUno=objres.ArchivoUno;
				this.ArchivoDos=objres.ArchivoDos;
				this.GetListaPrograma(this.ProyectoReporteObra.IdProyecto);
			})
		},
		SubirArchivo1(){
			const image = this.$refs.archivouno.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.archivouno;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivouno;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoUno='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoUno=image.name;
		},
		SubirArchivo2(){
			const image = this.$refs.archivodos.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.archivodos;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivodos;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoDos='Elegir archivo (0.5MB)';
                return false;
            }

            this.ArchivoDos=image.name;
		},
		async GetListaPrograma(IdProyecto){
			await this.$http.get('proyectoprograma/get',{
				params:{
					IdProyecto:IdProyecto
				}
			}).then((res)=>{
				this.ListaProyectoPrograma=res.data.data.proyectoprograma;
			})
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoReporteObra.IdProyecto=IdProyecto;
				this.GetListaPrograma(this.ProyectoReporteObra.IdProyecto);
            }
            if (Id > 0) {
				this.ProyectoReporteObra.IdProyectoReporteObra = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        },
		validate(){
			if (this.pListProyectoReporteObra!=undefined) {
				this.ListProyectoReporteObra=this.pListProyectoReporteObra;
			}
		}
    }
}
</script>

<style>

</style>
